import api from 'services/api/microfwk';
import _ from 'lodash';
import { getProfileLastTouchFavorited } from 'utils/Socialization';

export const getFavoritedList = (params = {}) =>
  api
    .get('/services/user/favorited', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
export const addFavorited = (params = {}) =>
  api
    .get('/services/user/favoriteadd', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export const deleteFavorited = (params = {}) =>
  api
    .get('/services/user/favoritedel', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
